var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center mb-4"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"#3c8dbc","indeterminate":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }